import React from 'react'
import {connect} from 'react-redux'
import {List} from 'immutable'

import {
  CONVERSATION_TYPES
} from '../shared/config/constants'


import ChatListSegment from './chat_list_segment'

class ChatListRecentSegment extends React.Component {
  constructor (props) {
    super(props)

    this.state = {}
  }
  render () {
    return (
      <ChatListSegment
        label={this.props.title}
        emptyMessage='There are no users in your recents list.'
        conversationType={CONVERSATION_TYPES.MIXED}
        shouldShowUnreadMessageCount={true}
        shouldForceHideRatings={true}
        list={this.props.recents}/>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    title: state.getIn(['chatSettings', 'segments', 'recents', 'title']),
    recents: state.getIn(['chatListView', 'segments', 'recents', 'segment'], List())
  }
}

const ChatListRecentSegmentContainer = connect(
  mapStateToProps
)(ChatListRecentSegment)

export default ChatListRecentSegmentContainer



/** WEBPACK FOOTER **
 ** ./modules/chat_ui/chat_list_recent_segment.js
 **/